module.exports = __webpack_public_path__ + "static/media/business-small-placeholder.a3273c36.webp";